import React from "react";
import { useFormContext } from "./Form";
import useField, { fieldPropTypes } from "./field";

const Select = ({
    children,
    ...props
}) => {
    const context = useFormContext();
    const { key, errors, fieldProps } = useField(props, context);

    return [
        <select key={key} {...fieldProps}>
            {children}
        </select>,
        ...errors.elements,
    ];
};

Select.propTypes = {
    ...fieldPropTypes,
};

export default Select;
